<template>
  <NuxtLink :class="['block', isDarkTheme ? 'text-white' : 'text-gray9']" :to="`/experiences/${experience.slug}/`" @click="handleClick">
    <div class="group font-Spectral">
      <div :class="['block w-full', isVertical ? 'md:flex md:flex-row' : '']">
        <div :class="['mb-2 max-w-full overflow-hidden', isVertical ? 'min-w-[280px] md:w-64' : '']">
          <ExperienceCarousel :disable-carousel-on-sp="props.disableCarouselOnSp" :fixed-image-aspect="true" :images="props.experience.images ?? []" :is-vertical="orientation === 'vertical'" />
        </div>
        <div :class="[isVertical ? 'md:ml-4 md:flex md:flex-col md:justify-center' : '']">
          <ExperienceCardContent :experience="experience" :theme="props.theme" />
        </div>
      </div>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import { ExperienceCardContent, ExperienceCarousel } from '@/wabunka-src/features/Experience';
import type { ExperienceViewModel } from '@/wabunka-src/features/Experience';

interface Props {
  experience: ExperienceViewModel;
  // テーマを指定
  theme: 'light' | 'dark';
  // 縦並びか横並びかを指定
  orientation: 'vertical' | 'horizontal';
  // 画像のカルーセルをスマホでOFFにするかどうか（横スクロールができるUIだと、アクションが被ってUXが悪くなるため）
  disableCarouselOnSp?: boolean;
  // クリックイベントハンドラ
  onExperienceClick?: (experienceSlug: string) => void;
}

/**
 * 🚨 体験シリーズ機能を導入する場合、忘れずにセクションviewイベントを新しいコンポーネントに付与すること（その時にはシリーズIDという呼び名かも）
 *  sendGAWabunkaSectionViewEvent(props.sectionId, route.name);
 *  sendGAWabunkaSectionExperienceViewEvent(props.sectionId, props.enExperience.id, route.name);
 */

const props = withDefaults(defineProps<Props>(), {
  theme: 'light',
  orientation: 'vertical',
  disableCarouselOnSp: false,
});

const handleClick = () => {
  if (props.onExperienceClick) {
    props.onExperienceClick(props.experience.slug);
  }
};

const isDarkTheme = computed(() => props.theme === 'dark');
const isVertical = computed(() => props.orientation === 'vertical');
</script>
